import React, { FC } from 'react'
import { NavDropdown } from 'react-bootstrap'
import { CompanyIdUrlParam, ProjectIdUrlParam, TemplateIdUrlParam } from 'types'
import { useAppContext } from 'state/context'
import { moveTemplate } from 'state/async_actions'
import { navigate } from 'hookrouter'
import { useDirectories } from 'hooks/useTemplatesForProject'

export const DefaultDropdownText = 'Move Template to Folder'
export type DuplicateTemplateParams = CompanyIdUrlParam &
  ProjectIdUrlParam &
  TemplateIdUrlParam

export const MoveTemplateSelector: FC<DuplicateTemplateParams> = ({
  companyId,
  projectId,
  templateDocumentId,
}) => {
  let templates:any = useDirectories() || []; 
  // templates = templates.filter((template:any) => template?.isDirectory == true)
console.log("direct", templates);

  const [, dispatch] = useAppContext()
  return (
    <NavDropdown
      title={DefaultDropdownText}
      id="project-nav-dropdown"
      className="duplicate-project">
      {templates
        .map((template: any) => {
          const onSelect = () => {
            moveTemplate(dispatch, template.id, templateDocumentId)
            navigate(`/company/${companyId}/project/${projectId}`)
          }
          return (
            <div style={{width: '80%', display:'inline-flex'}}>
              <NavDropdown.Item key={template.id} onSelect={onSelect}>
                {template.name}
              </NavDropdown.Item>
              {(template?.childDirectories?.length > 0) && <NavDropdown title="Move to Sub Folder"
                  id="project-nav-sub-dropdown"
                  className="duplicate-project">
              { template?.childDirectories?.map((child: any) => {
                const onChildSelect = () => {
                  moveTemplate(dispatch, child.id, templateDocumentId)
                  navigate(`/company/${companyId}/project/${projectId}`)
                }
                 return (<NavDropdown.Item key={child.id} onSelect={onChildSelect}>
                    {child.name}
                  </NavDropdown.Item>)
                   })
                  }
                </NavDropdown>
        }
            </div>
          )
              })
        }
    </NavDropdown>
  )
}
